import React, { Dispatch, SetStateAction } from 'react';
import useHeaderHooks from './menuHeader-hook';
import { useNoAuthHooks } from '../../../../../../../../Hooks/hooks';
import { IBusinessProfile, IMenuListItem, IServices } from '../../../../../../../../Interfaces/responseTypes';
import { DrawerOpenSides } from '../../../../../../../../Interfaces/componentTypes';
import { MenuSearchResult } from '../../../../../../../../Components/Inputs/SearchInput/SearchMenuItem/searchMenu-hooks';
import Logo from '../../../../../../../Business/Restaurant/Components/Logo/logo';
import SearchMenu from '../../../../../../../../Components/Inputs/SearchInput/SearchMenuItem/searchMenu';
import { MenuIcon, SearchIcon, SettingIcon } from '../../../../../../../../Components/IconComponents';
import CustomDialog from '../../../../../../../../Components/Dialog/customDialog';
import CustomDrawer from '../../../../../../../../Components/Drawer/CustomDrawer/customDrawer';
import { VisitorPageContents } from '../../../../../visitorPage';
import styles from './menuHeader.module.scss';

export interface IVisitorMenuHooks {
    title: string,
    logo: string
    menu_list: IMenuListItem[];
    business_profile?: IBusinessProfile,
    companyId: number,
    onClickLogo: () => void;
    searchHandler: (result: MenuSearchResult) => void,
    setContentType: Dispatch<SetStateAction<VisitorPageContents>>,
    is_user: boolean,
    services: IServices | null;
    onOpenReserveDialog: () => void
};

const Header: React.FC<IVisitorMenuHooks> = (props) => {
    const { title, logo, menu_list, business_profile, services, onClickLogo, searchHandler } = props;
    const { baseURL, largeScreen, mobileScreen, mediumScreen } = useNoAuthHooks();
    const {
        open,
        openDrawer,
        dialogComponent,
        drawercomponent,
        onClose,
        onOpenMenuDrawer,
        onOpenSearchDrawer,
        onOpenSettingDialog,
        onCloseHeaderDrawer,
    } = useHeaderHooks(props);

    return (
        <div className={styles.header} >
            <Logo onClick={onClickLogo} imageUrl={logo} baseURL={baseURL!} />
            <p className={`${styles.title} ${title.length > 20 && !mediumScreen ? styles.longTitle : ''} ${title.length > 12 && mobileScreen ? styles.hideTitle : ''}`}>
                {title}
            </p>
            <div className={styles.navBox}>
                {
                    largeScreen
                        ?
                        <SearchMenu
                            menu_list={menu_list}
                            searchHandler={searchHandler}
                            containerStyles={styles.serchBox}
                        />
                        :
                        <div className={styles.headerIcon}>
                            <SearchIcon color='var(--icon-color)' width={23} height={23} onClick={onOpenSearchDrawer} />
                        </div>
                }
                {
                    business_profile && !mobileScreen
                        ?
                        <div className={styles.menuIcon}>
                            <MenuIcon color='var(--icon-color)' width={23} height={23} onClick={onOpenMenuDrawer} />
                        </div>
                        :
                        (
                            services?.reserve
                                ?
                                <div className={styles.headerIcon}>
                                    <MenuIcon onClick={onOpenMenuDrawer} color="var(--icon-color)" width={23} height={23} />
                                </div>
                                :
                                <div className={styles.headerIcon}>
                                    <SettingIcon onClick={onOpenSettingDialog} color="var(--icon-color)" />
                                </div>
                        )

                }
            </div>
            <CustomDialog
                open={open}
                onClose={onClose}
                children={dialogComponent}
            />
            <CustomDrawer
                openSide={DrawerOpenSides.Right}
                children={drawercomponent}
                open={openDrawer}
                onClose={onCloseHeaderDrawer}
            />
        </div>
    )
}

export default Header
